import { NgModule } from "@angular/core";
import { SharedModule } from "../shared/shared.module";
import { LoginWithPinComponent } from "src/app/waiter-panel/components/login-with-pin/login-with-pin/login-with-pin.component";
import { WaiterRoutingModule } from "./waiter-routing.module";
import { VenuesComponent } from "src/app/waiter-panel/components/venues/venues/venues.component";
import { WaiterTabviewComponent } from "src/app/waiter-panel/components/waiter-tabview/waiter-tabview.component";
import { ManagerPinDialogComponent } from "src/app/waiter-panel/components/manager-pin-dialog/manager-pin-dialog.component";
import {CustomCurrencyPipe} from "../../waiter-panel/services/custom-currency-pipe.pipe";
@NgModule({
    declarations: [
        VenuesComponent,
        LoginWithPinComponent,
        WaiterTabviewComponent,
        ManagerPinDialogComponent,
        CustomCurrencyPipe
    ],
    imports: [
        WaiterRoutingModule,
        SharedModule,
    ],
    exports: [
        ManagerPinDialogComponent,
        CustomCurrencyPipe
    ]


})

export class WaiterModule { }
